import { render, staticRenderFns } from "./audioPlay.vue?vue&type=template&id=4c620f59"
import script from "./audioPlay.vue?vue&type=script&lang=js"
export * from "./audioPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports